import { render, staticRenderFns } from "./DoctorCardSelect.vue?vue&type=template&id=9083a3cc"
import script from "./DoctorCardSelect.vue?vue&type=script&lang=js"
export * from "./DoctorCardSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports